import { render, staticRenderFns } from "./SectionConsultants_Distributors.vue?vue&type=template&id=9c70873a&scoped=true&"
import script from "./SectionConsultants_Distributors.vue?vue&type=script&lang=js&"
export * from "./SectionConsultants_Distributors.vue?vue&type=script&lang=js&"
import style0 from "./SectionConsultants_Distributors.vue?vue&type=style&index=0&id=9c70873a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c70873a",
  null
  
)

export default component.exports